import { useCallback } from 'react';
import { toast } from 'sonner';

export default function usePdfHighlightRemoval({ removeHighlight }) {
  const handleRemoveHighlightById = useCallback(async (highlightId) => {
    if (!highlightId && highlightId !== 0) {
      console.warn('Cannot remove highlight: ID is missing');
      return;
    }

    if (!removeHighlight) {
      console.warn('Cannot remove highlight: removeHighlight function not available');
      return;
    }

    try {
      console.log('🗑️ Removing highlight:', highlightId);
      const success = await removeHighlight(highlightId);

      if (success) {
        toast.success('Highlight removed!');
        window.getSelection()?.removeAllRanges();

        const highlightedSpans = document.querySelectorAll(`span[data-highlight-id="${highlightId}"]`);
        highlightedSpans.forEach((highlightedSpan) => {
          const parent = highlightedSpan.parentNode;
          if (parent) {
            const textContent = Array.from(highlightedSpan.childNodes)
              .filter((node) => node.nodeType === Node.TEXT_NODE || (node.nodeType === Node.ELEMENT_NODE && !node.classList?.contains('highlight-remove-btn')))
              .map((node) => node.textContent || node.innerText || '')
              .join('');

            const textNode = document.createTextNode(textContent);
            parent.replaceChild(textNode, highlightedSpan);
            parent.normalize();
          }
        });
        console.log('✅ Removed highlight span(s) from DOM:', highlightedSpans.length);
      } else {
        toast.error('Failed to remove highlight');
      }
    } catch (error) {
      console.error('Error removing highlight:', error);
      toast.error('Failed to remove highlight: ' + (error.message || 'Unknown error'));
    }
  }, [removeHighlight]);

  return { handleRemoveHighlightById };
}
